import { render, staticRenderFns } from "./CustomDiaplay.vue?vue&type=template&id=e04d0056&scoped=true&"
import script from "./CustomDiaplay.vue?vue&type=script&lang=js&"
export * from "./CustomDiaplay.vue?vue&type=script&lang=js&"
import style0 from "./CustomDiaplay.vue?vue&type=style&index=0&id=e04d0056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04d0056",
  null
  
)

export default component.exports